// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormEditBeneficiary } from '../../forms/FormEditBeneficiary/FormEditBeneficiary';

// props
export interface DialogEditBeneficiaryProps {
	DialogActionsProps?: Partial<DialogActionsProps>;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditBeneficiary = ({
	DialogActionsProps = {},
	isOpen,
	onClose,
	onSuccess,
}: DialogEditBeneficiaryProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	DialogActionsProps.actions = [
		{
			children: t('cancel'),
			onClick: onClose,
		},
		{
			children: t('saveBeneficiary'),
			form: 'form-edit-beneficiary',
			loading: isLoading,
			type: 'submit',
			variant: 'contained',
		},
	];
	DialogActionsProps.title = {
		children: t('editBeneficiary'),
		variant: 'h3',
	};

	return (
		<DialogActions hasClose={true} isOpen={isOpen} onClose={onClose} {...DialogActionsProps}>
			<FormEditBeneficiary onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
